import React from "react";
import { useHistory } from "react-router-dom";
import Dropdown from "react-multilevel-dropdown";

const NavbarItem = ({data}, props) => {
    const history = useHistory();

    const handleClick = (e, item) => {
        // console.log('NavbarItem.handleClick: ', e, item);
        if (!item?.url) return;

        //console.log('NavbarItem.handleClick: ', item.url, item.url.trim().startsWith('http'));
        if(item.url.trim().startsWith('http'))
            window.open(item.url, '_blank');
        else
            history.push(`${item.url}`);
    }

    if(data
        && data.length>0){
        return(
            data.map(item => 
                !item.children
                ?<Dropdown.Item key={item.id} data-key={`${item?.url}`} onClick={(e) => handleClick(e, item)} >{item.title}</Dropdown.Item>
                :<Dropdown.Item key={item.id}>{item.title}
                    <Dropdown.Submenu key={`submenu-${item.id}`} position="right" className="submenu-right-98">
                        <NavbarItem data={item.children} />
                    </Dropdown.Submenu>
                </Dropdown.Item>
            )
        )
    }

    return ( "" )
};

export default NavbarItem;